/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProxyGeneratorProperties,
    ProxyGeneratorPropertiesFromJSON,
    ProxyGeneratorPropertiesFromJSONTyped,
    ProxyGeneratorPropertiesToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProxyGenerator
 */
export interface ProxyGenerator {
    /**
     * 
     * @type {string}
     * @memberof ProxyGenerator
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyGenerator
     */
    name: string;
    /**
     * 
     * @type {ProxyGeneratorProperties}
     * @memberof ProxyGenerator
     */
    properties: ProxyGeneratorProperties;
}

export function ProxyGeneratorFromJSON(json: any): ProxyGenerator {
    return ProxyGeneratorFromJSONTyped(json, false);
}

export function ProxyGeneratorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProxyGenerator {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'properties': ProxyGeneratorPropertiesFromJSON(json['properties']),
    };
}

export function ProxyGeneratorToJSON(value?: ProxyGenerator | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'properties': ProxyGeneratorPropertiesToJSON(value.properties),
    };
}


